<template>
  <section class="custom-chart">
    <vue-highcharts
      type="chart"
      ref="vchart"
      :options="options"
      :redrawOnUpdate="true"
      :oneToOneUpdate="false"
      :animateOnUpdate="true"
    />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'bodyfat-chart',
  components: {
    VueHighcharts,
  },
  computed: {
    ...mapGetters('bodycomposition', ['bodycomposition']),
    series() {
      let _data = []
      if (this.bodycomposition) {
        if (this.bodycomposition.plotdatabodyfat) {
          _data = this.bodycomposition.plotdatabodyfat
        }
      }
      console.log('Body Fat Data', _data)
      return _data
    },
    options() {
      let _options = {
        chart: {
          type: 'spline',
          animation: false,
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: 'category',
          labels: {
            enabled: true,
            formatter: function () {
              // if (chartspan === 'month') {
              //   return new Date(this.value).getDate()
              // } else {
              return this.value
              // }
            },
          },
          title: {
            text: 'Day',
          },
        },
        yAxis: {
          title: {
            text: 'Body Fat (%)',
          },
          minorGridLineWidth: 0,
          gridLineWidth: 0,
          alternateGridColor: null,
        },
        tooltip: {
          valueSuffix: '%',
          formatter: function () {
            return (
              'Body Fat on <b>' + this.key + '</b> was <b>' + this.y + '%</b>'
            )
          },
        },
        plotOptions: {
          spline: {
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 3,
              },
            },
            marker: {
              enabled: false,
            },
          },
        },
        series: [
          {
            name: '',
            data: this.series,
            color: '#0d6efd',
            animation: false,
          },
        ],
        navigation: {
          menuItemStyle: {
            fontSize: '10px',
          },
        },
      }
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-chart {
  width: auto;
  height: auto;
  text-align: center;
  margin: 0 auto;
}
</style>
